export interface IMinLimit {
  minLength: number;
}

export interface IMaxLimit {
  maxLength: number;
}

export interface IMinMaxLimits {
  minLength: number;
  maxLength: number;
}

export interface ILimits {
  name: IMinMaxLimits;
  title: IMinMaxLimits;
  caption: IMinMaxLimits;
  mobile: IMinMaxLimits;
  password: IMinLimit;
}

export interface IMasks {
  nameMask: RegExp;
  titleMask: RegExp;
  socialIDMask: RegExp;
  socialIDInputMask: RegExp;
  passwordMask: RegExp;
  passwordInputMask: RegExp;
  emailMask: RegExp;
  emailInputMask: RegExp;
  mobileMask: RegExp;
  urlMask: RegExp;
  removeSpecialCharacters: RegExp;
}

export const Masks: IMasks = {
  nameMask: new RegExp(/^[a-zA-Z]*$/),
  titleMask: new RegExp(/^[a-zA-Z0-9]*$/),
  socialIDMask: new RegExp(/^[a-zA-Z][a-zA-Z0-9-@_.]*$/),
  socialIDInputMask: new RegExp(/^[a-zA-Z0-9-@_.]*$/),
  passwordMask: new RegExp(/(?=^.{6,}$)((?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=(.*\d)+)(?=.*[ !()\-+.?{}\[\]_`~;:@#$%^&*=<>'"/\\])).*$/),
  passwordInputMask: new RegExp(/^[a-zA-Z0-9 !()\-+.?{}\[\]_`~;:@#$%^&*=<>'"/\\]*$/),
  emailMask: new RegExp(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
  emailInputMask: new RegExp(/^[a-z0-9@._%+-]*$/),
  mobileMask: new RegExp(/^[0-9]*$/),
  urlMask: new RegExp(/^(http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/),
  removeSpecialCharacters: new RegExp(/[ `~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi)
};

export enum MediaTypes {
  file = 'file',
  image = 'image',
  gif = 'gif',
  video = 'video',
  audio = 'audio',
  thumbnail = 'thumbnail',
  icon = 'icon',
  iconThumbnail = 'iconThumbnail',
  media = 'media',
  mediaThumbnail = 'mediaThumbnail',
  menuMedia = 'menuMedia'
}

